module.exports = __webpack_public_path__ + "img/1_12_1.7c0422d6.jpg";